import { SelectItem } from "primeng/api";
import { MainComplaintStatus } from "../enums";

export class MainComplaintStatusesLookup {

    static getLookup(): any[] {
        return [
            { label: 'Active', value: MainComplaintStatus.Active },
            { label: 'Resolved', value: MainComplaintStatus.Resolved },
        ];
    }

    static getTitleById(id) {
        return this.getLookup().find(f => f.value === id)?.label || '';
    }

    static getById(id) {
        return this.getLookup().find(f => f.value === id)|| null;
    }
    
    static getLookupStatus(): SelectItem[] {
        return [
            { label: 'All', value: null },
            { label: 'Active', value: false },
            { label: 'Resolved', value: true }
        ];
    }
}